// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1t4oB","bigColWidth":"Table_bigColWidth__2y44b","biggerColWidth":"Table_biggerColWidth__2uvL2","row":"Table_row__fKtFW","col":"Table_col__mAMXC"};